import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import { Autocomplete, FormControl, TextField } from '@mui/material';

interface IProps extends UseControllerProps {
    label?: string;
    size?: "small" | "medium";
    disabled?: boolean;
}

export interface IYesOrNoOptions {
    label: string;
    value?: boolean;
}

const yesOrNoOptions: IYesOrNoOptions[] = [
    { label: "No", value: false },
    { label: "Yes", value: true },
];

const AppYesOrNoSelect = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: null });
    let value = yesOrNoOptions.find(x => x.value == field.value) || null;
    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <Autocomplete
                {...props}
                {...field}
                value={value}
                defaultValue={null}
                onChange={(event, value) => {
                    if (value) {
                        field.onChange(value.value);
                    } else {
                        field.onChange(null);
                    }
                }}
                options={yesOrNoOptions}
                getOptionLabel={option => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={
                    (params) => <TextField
                        {...params}
                        fullWidth
                        label={props.label}
                        variant="outlined"
                        size={props.size}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                }
                disabled={props.disabled || false}
            />
        </FormControl>
    )
}

export default AppYesOrNoSelect